import { useSuspenseQuery } from '@tanstack/react-query';

import { fetchAssessmentStatic, mapStaticResponseToConfig } from '../api/assessmentApi';
import { useAssessmentStore } from '../stores/useAssessmentStore';
import type { AssessmentStaticResponse } from '../types';

export const assessmentKeys = {
  all: ['assessment'] as const,
  static: (publicUrl: string) => [...assessmentKeys.all, 'static', publicUrl] as const,
  progress: (publicUrl: string) => [...assessmentKeys.all, 'progress', publicUrl] as const,
};

export function useAssessment(publicUrl: string): { data: AssessmentStaticResponse } {
  const setConfig = useAssessmentStore((s) => s.setConfig);

  return useSuspenseQuery({
    queryKey: assessmentKeys.static(publicUrl),
    queryFn: async () => {
      const data = await fetchAssessmentStatic(publicUrl);
      const config = mapStaticResponseToConfig(data);
      setConfig(config);
      return data;
    },
    staleTime: Infinity,
    retry: false,
  });
}
